import {useTranslation} from 'react-i18next';

export const useEditParagraphsFormTranslations = () => {
	return useTranslation('features/regulatorydocuments', {
		keyPrefix: 'ParagraphsForm',
	});
};

export const useEditMatkonParagraphsFormTranslations = () => {
	return useTranslation('features/matkon', {
		keyPrefix: 'Form',
	});
};

export const useEditMatkonParagraphsFormEnumsTranslations = () => {
	return useTranslation('features/matkon', {
		keyPrefix: 'FormEnums',
	});
};
